import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import studentScore from "./studentScore.vue";
export default {
  mixins: [loadMoreList, commonData],
  components: {
    studentScore: studentScore
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      trainingPlanId: '',
      tableData: [],
      total: 0
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.trainingPlanId = data;

                  _this.getStudentListFn();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getStudentListFn: function getStudentListFn() {
      var _this2 = this;

      this.$api.studentList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        training_plan_id: this.trainingPlanId
      })).then(function (res) {
        if (res.code == 200) {
          _this2.tableData = res.data.data;
          _this2.total = res.data.total;
        }
      });
    }
  }
};